<template>
  <CanvasIndex :height="500" :img-url="imgUrl" :width="500"></CanvasIndex>
</template>

<script>
  import CanvasIndex from '../../components/canvas/index.vue'

  export default {
    name: 'PortalCanvas',
    components: {
      CanvasIndex
    },
    data() {
      return {
        imgUrl: '/medias/GJ-1672900754500/thumbnails/0001/large.jpg'
      };
    },

    mounted() {

    },

    methods: {},
  };
</script>

<style lang="less" scoped>

</style>
